import script from "./DefSKUWeights.vue?vue&type=script&lang=ts&setup=true"
export * from "./DefSKUWeights.vue?vue&type=script&lang=ts&setup=true"

import "./DefSKUWeights.vue?vue&type=style&index=0&id=322093c0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-322093c0"]])

export default __exports__